import type { QueryClient } from '@tanstack/react-query';

import { updateClassroomsCount } from './cache-utils';

type MoveStudent = {
  queryClient: QueryClient;
  organizationId: string;
  fromClassroomId: string;
  toClassroomId: string;
};

type RecoverStudent = {
  queryClient: QueryClient;
  organizationId: string;
  classroomId: string;
};

function moveStudentInCache({
  queryClient,
  organizationId,
  fromClassroomId,
  toClassroomId,
}: MoveStudent): void {
  updateClassroomsCount({
    queryClient,
    organizationId,
    updates: [
      { classroomId: fromClassroomId, countChange: -1 },
      { classroomId: toClassroomId, countChange: 1 },
    ],
  });
}

function recoverStudentInCache({
  queryClient,
  organizationId,
  classroomId,
}: RecoverStudent): void {
  updateClassroomsCount({
    queryClient,
    organizationId,
    updates: [{ classroomId, countChange: 1 }],
  });
}

export { moveStudentInCache, recoverStudentInCache };
